import { h } from "preact";

/**
 * Круглые свотчи цвета.
 *
 * Пропсы:
 *   colors   — [{ name, value }]
 *   selected — выбранное имя цвета
 *   onchange — колбэк (name) => void
 */
export function ColorList({ colors = [], selected, onchange }) {
  return h("fieldset", { class: "color-list" },
    colors.map(({ name, value }) =>
      h("button", {
        key: name,
        type: "button",
        title: name,
        "aria-label": name,
        onClick: () => onchange(name),
        class: "color-list__item" + (selected === name ? " is--selected" : ""),
        style: `background-color: ${value}`,
      })
    )
  );
}
